angular.module('kareo.ui.shared.directives.outstanding-items', ['api', 'kareo.featureSetAreas', 'kareo.ui.shared.modules.api.user.k-user-service'])

.controller('OutstandingItemsCtrl', [
  '$http', '$scope', 'api/FeatureToggle', 'api/OutstandingTasks',
  'authenticatedUser', 'featureSet', 'featureSetAreas', '$q', 'activeCustomerProducts', 'kUserService'
  ($http, $scope, featureToggle, outstandingTasks,
    authenticatedUser, featureSet, featureSetAreas, $q, activeCustomerProducts, kUserService) ->
    priority = 1

    script_type = 'Rx'
    lab_type = 'Lab'
    message_type = 'Memo'
    open_notes_type = 'OpenNote'

    load_count = 0
    post_load_check = ->
      load_count += 1
      $scope.loaded = load_count >= 3

    featureToggle.restLoad {}, post_load_check
    $scope.enabledFeature = featureToggle.map
    $scope.counts = counts = {}
    $scope.knownClinicalInfo = {}

    common_url = '/messages?date=all&page=1&sort=updated_at&sort_order=desc&'
    $scope.urls = urls =
      ehrTasksScripts: common_url + 'category=rx&view=new'
      ehrTasksNewLabs: '/labs-ui/#/practice/?needState=true'
      ehrTasksOpenNotes: '/messages/show_open_notes'
      ehrTasksMessagesFlagged: '/messages-ui/#/messages/flagged/'
      tentativeAppointments: '/patient-engagement-ui/#/tentative-appointments'
      billingTasks: '/billing-tasks-ui/'
      userUpDoxAccess : '/EhrWebApp/referrals/toc/flags'
      directMsgsCount: '/EhrWebApp/referrals/toc/msgCount'
      directInbox: '/EhrWebApp/referrals/directinboxurl'
      patientIntake: '/patient-intake-admin-ui/#/intakes/'

    $scope.openDirectInbox = () ->
      $http.get(urls.directInbox)
        .then (resp) ->
          window.open(resp.data, '_blank');

    $q.all([
      featureSet.load()
      featureSetAreas.load()
      activeCustomerProducts.get()
      kUserService.isRcmEmployee()
      authenticatedUser.get()
    ]).then (responses) ->
      initFeatures(responses[0], responses[1], responses[2], responses[3])

    initFeatures = (featureSet, featureSetAreas, customerProduct, isRcmEmployee)->
      darkFeature = !!featureSet['dark-feature.kareo-base-product']
      outstandingAgendaFeature = !!featureSetAreas['feature-set.area.agenda'].show
      outstandingClinicalFeature = !!featureSetAreas['feature-set.area.agenda-clinical'].show
      outstandingBillingFeature = !!featureSetAreas['feature-set.area.agenda-billing'].show
      purchasedFeature = !!featureSetAreas['feature-set.product.marketing'].enabled || !!featureSetAreas['feature-set.product.clinical'].enabled ||
          !!featureSetAreas['feature-set.product.billing'].enabled
      isKmbCustomer = !!customerProduct.RCM
      isRelaxedPlatformPerm = !!featureSet['dark-feature.billing-tasks-relaxed-platform-perm']
      erxFeature = !!featureSet['dark-feature.2015cert-erx-changes']

      $scope.showOutstandingItems = outstandingAgendaFeature
      $scope.showScripts = !darkFeature || outstandingClinicalFeature
      $scope.showLabStudies = !darkFeature || outstandingClinicalFeature
      $scope.showOpenNotes = (!darkFeature || outstandingClinicalFeature) &&
          (featureSet['dark-feature.complete-non-clinical-note'] || authenticatedUser.hasRole('Provider') ||
            authenticatedUser.hasRole('Clinical Assistant'))
      $scope.showTentativeAppointments = purchasedFeature
      $scope.showBillingTasks = !darkFeature || outstandingBillingFeature || (isKmbCustomer && featureSet['dark-feature.billing-tasks-relaxed-platform-perm'])
      $scope.showErxFeature = erxFeature
      $scope.showDirectInboxFeature = !!featureSet['dark-feature.2015cert-agenda-direct-inbox']
      $scope.showPendingPatientIntakes = (!!featureSetAreas['feature-set.area.patient-broadcast'].show && !!featureSet['dark-feature.patient-intake-mvp'] &&
          (authenticatedUser.hasRole('Office Staff') || authenticatedUser.hasRole('System Administrator')))

      authenticatedUserSuccess(isRcmEmployee, isRelaxedPlatformPerm)

      if purchasedFeature
        $http.get('/patient-engagement-ui/api/v2/tentative-appointments/count').then (response) ->
          counts.tentativeAppointments = response.data
      else
        counts.tentativeAppointments = 0

      $scope.showDirectInboxFeature && getUserUpDoxSignUpStatus()
        .then loadDirectMessages

    $http.get('/messages-ui/api/ConversationList/Count?stateFilter=FLAGGED').then (response) ->
      counts.flaggedMessages = response.data.totalCount


    authenticatedUserSuccess = (isRcmEmployee, isRelaxedPlatformPerm)->
      check = authenticatedUser.hasPrivilegeAccess

      AUTH__MESSAGES = 32
      AUTH__PATIENT_CHART = 34
      AUTH__LABS_VIEW = 14
      AUTH__NOTES = 35
      AUTH__READ = 1
      AUTH__WRITE = 2
      $scope.messagesPriv = check AUTH__MESSAGES, AUTH__WRITE
      $scope.chartPriv = check AUTH__PATIENT_CHART, AUTH__READ
      $scope.notesPriv = check AUTH__NOTES, AUTH__WRITE
      $scope.labPriv = check AUTH__LABS_VIEW, AUTH__READ

      if featureSet.features()['dark-feature.kmb.cwq']
        url = '/billing-tasks-ui/api/shared/TotalCount?isRCMEmployee=' + isRcmEmployee + '&relaxedPermissionsFeature=' + isRelaxedPlatformPerm
        $http.get(url).then (response) ->
          $scope.counts.totalBillingTasks = response.data

      $http.get('/labs-ui/api/LabOrder/Practice/LabsCount').then (response) ->
        $scope.counts.newLabs = response.data

      $http.get('/dashboard-calendar-ui/api/OutstandingTasks/knownClinicalInfo').then (response) ->
        $scope.knownClinicalInfo = response.data

      if ($scope.showPendingPatientIntakes)
        PENDING_STATUSID = 3;
        $http.get('/patient-intake-ui/api/PatientIntake/Count?statuses=' + PENDING_STATUSID).then (response) ->
          counts.patientIntakesPendingMerges = response.data.count

      post_load_check()

    outstandingTasks.restLoad (err) ->
      find = (data, type, priority) ->
        res = data.filter (obj) ->
          obj.type is type and (not priority? or obj.priority is priority)
        res?.length or 0

      post_load_check()
      if err
        return $scope.loadError = true

      counts.scripts = find outstandingTasks, script_type, priority
      counts.labs = find outstandingTasks, lab_type, priority
      counts.messages = find outstandingTasks, message_type, priority
      counts.open_notes = find outstandingTasks, open_notes_type

    getUserUpDoxSignUpStatus = () =>
      return $http.get(urls.userUpDoxAccess)
        .then (resp) =>
          return $scope.hasDirectMsgAccount = resp.data.tocUserExists

    loadDirectMessages = (status) =>
      if status
        return $http.get(urls.directMsgsCount)
          .then (resp) =>
            count = resp.data
            if !isNaN(parseInt(count)) && isFinite(count)
              counts.totalDirectMsgCount = parseInt(count)
])

.directive 'outstandingItems', ->
  restrict: 'E'
  replace: true
  controller: 'OutstandingItemsCtrl',
  template: require('./outstanding-items.pug')()
